<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
    <p style="color: white">
      Loading... </p>
  </ngx-spinner>
  <section id="maingroupcut">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <h2>สถานะการตัด ปี 2567/2568</h2>
          </div>
          <div class="col">
            <!--<ul class="nav nav-pills bg-gradient-warning" style="text-align:center">
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="pill" href="#tabs-editcut">บันทึกสถานะการตัด</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-toggle="pill" href="#tabs-showdata"
                    (click)="LoadNewData2()">ข้อมูลแปลงตัดเสร็จ</a>
                </li>
              </ul>-->
            <ul class="nav nav-pills mb-3 d-flex align-items-center" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="btn btn-outline-success active" data-toggle="pill" href="#tabs-editcut">บันทึกสถานะการตัด</a>
              </li>
              <li class="nav-item">
                <a class="btn btn-outline-secondary" data-toggle="pill" href="#tabs-showdata"
                  (click)="LoadNewData2();">ข้อมูลแปลงตัดเสร็จ</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="tab-content" id="vert-tabs-tabContent">
          <div class="tab-pane text-left fade active show" id="tabs-editcut" role="tabpanel"
            aria-labelledby="vert-tabs-allcane-tab">
            <div class="row justify-content-md-center">
              <div class="col-md-auto">
                <div class="input-group mb-3">
                  <label class="input-group-text" for="select_type">เลือกการค้นหา</label>
                  <select class="form-select" id="seelect_type" [(ngModel)]="type_select">
                    <option value="1">โซน/รูท</option>
                    <option value="2">โควตาชาวไร่</option>
                  </select>
                </div>

              </div>
              <div class="col-md-auto" *ngIf="type_select==1">
                <div class="input-group mb-4" [formGroup]="FormCutGroup">
                  <span class="input-group-text" id="basic-addon1">โซน</span>
                  <select class="form-select" formControlName="zoneid">
                    <option selected disabled>เลือกโซน</option>
                    <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}}</option>
                  </select>
                  <input type="text" class="form-control" placeholder="หมายเลข รูท" maxlength="5"
                    formControlName="rootid" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                  <button mat-raised-button color="warn" (click)="LoadNewData();">ค้นหา</button>
                  <!--<mat-checkbox class="form-control" formControlName="Check_not" [(ngModel)]="Check_not" id="n01">ไม่ต้องรีเฟสข้อมูลใหม่</mat-checkbox>       -->
                  <!--&nbsp;&nbsp;
                  <p><input type="checkbox" (click)="doAction($event)"> ไม่ต้องรีเฟสข้อมูลใหม่ </p>-->
                </div>
              </div>
              <div class="col-md-auto" *ngIf="type_select==2">
                <div class="input-group mb-4">
                  <span class="input-group-text" id="basic-addon1">ใส่โควตาชาวไร่ 10 หลัก</span>
                  <input type="text" class="form-control" [(ngModel)]="fmcode" placeholder="โควตาชาวไร่" maxlength="10"
                    name="fmcode" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                  <button mat-raised-button color="warn" (click)="LoadNewData();">ค้นหา</button>
                </div>
              </div>

              <div class="col-md-auto" *ngIf="fmdata.length > 0">
                <div class="button-row">
                  <span class="badge bg-warning">{{ fmdata.length }}</span> รายการ
                  &nbsp; &nbsp;
                  <button mat-raised-button *ngIf="!edit_st" (click)="edit_st = true">
                    <mat-icon style="color: blue;">edit</mat-icon>แก้ไข
                  </button>&nbsp;
                  <button mat-raised-button *ngIf="edit_st" (click)="saveData();">
                    <mat-icon style="color: green;"> done </mat-icon>บันทึก
                  </button>&nbsp;
                  <button mat-raised-button *ngIf="edit_st" (click)="edit_st = false">
                    <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                  </button>
                </div>
              </div>
              <div class="col-md-auto" *ngIf="fmdata.length > 0">
                <mat-form-field class="example-full-width" style="text-align:center">
                  <input matInput [(ngModel)]="text_f" [ngModelOptions]="{standalone: true}" placeholder="คำค้นหา"
                    style="text-align:center">
                  <button *ngIf="text_f" matSuffix mat-icon-button aria-label="Clear" (click)="text_f=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <b style="color: red;text-align:right">ถ้าหากต้องการ *บันทึกวันตัดเสร็จ ต้องเลือก **ผลลัพธ์
              การตัดเสร็จก่อน</b>
            <mat-card class="example-card">
              <div class="table-responsive p-2" style="height: 600px">
                <table class="table table-head-fixed table-hover table-striped table-bordered" *ngIf="fmdata.length>0">
                  <thead>
                    <tr class="headText text-primary" style="text-align:center">
                      <th>.</th>
                      <th>หมายเลขแปลง</th>
                      <th>โซน</th>
                      <th>รูท</th>
                      <th>ชื่อ - สกุล</th>
                      <th>ประเภทอ้อย</th>
                      <th>พื้นที่</th>
                      <th>ประเมิน</th>
                      <th>อ้อยเข้า</th>
                      <th>กลุ่ม</th>
                      <th>วันเริ่มตัด</th>
                      <th>วันตัดเสร็จ*</th>
                      <th [colSpan]="2">ผลลัพธ์**</th>
                      <th>ตัดพันธุ์</th>
                      <th>สถานะการตัด</th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody [ngSwitch]="edit_st">
                    <tr *ngFor="let dt of fmdata | filter:text_f; let i = index;" style="text-align:center">
                      <td>{{i+1}}</td>
                      <td>{{dt.intlandno}}</td>
                      <td>{{dt.supzone}}</td>
                      <td>{{dt.route}}</td>
                      <td style="text-align:left">{{dt.fmname}}</td>
                      <td>{{dt.CaneTypeName}}</td>
                      <td style="text-align:right">{{dt.landvalue | number:'1.2-2'}}</td>
                      <td style="text-align:right">{{dt.Assess_left | number:'1.2-2'}}</td>
                      <td style="text-align:right">{{dt.canein | number:'1.2-2'}}</td>

                      <td>{{dt.groupCode}}</td>
                      <td class="text-center">
                        <div *ngSwitchCase="false">{{formatDate(dt.cutstart_sv) }}</div>
                        <div style="display: flex; max-width: 12rem;text-align:center;">
                          <mat-form-field appearance="fill" *ngSwitchCase="true">
                            <mat-label>เลือกวันเริ่มตัด {{formatDate(dt.cutstart_sv)}}</mat-label>
                            <input matInput style="text-align:center" [matDatepicker]="dp3"
                              style="text-align:center; background: #fffcad;" [ngModel]="dt.cutstart_edit"
                              (ngModelChange)="dt.cutstart_edit = Datetokeep($event); dt.modify = true;" disabled>
                            <mat-datepicker-toggle matSuffix [for]="dp3" color="primary"></mat-datepicker-toggle>
                            <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                            <button *ngIf="dt.cutstart_edit" matSuffix mat-icon-button color="warn" aria-label="Clear"
                              (click)="dt.cutstart_edit='';dt.modify = true;">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>
                        </div>
                        <!--<div style="color: chocolate;" *ngSwitchCase="false">{{formatDate(dt.cutstart_edit) }}</div>-->
                      </td>

                      <td class="text-center">
                        <div *ngSwitchCase="false">{{formatDate(dt.cutstop_sv) }}</div>
                        <div style="display: flex; max-width: 12rem;text-align:center;"
                          *ngIf="edit_st && (!dt.docCheckCutF_edit||cutstatus_sv=='F')">
                          <mat-form-field appearance="fill">
                            <mat-label>เลือกวันตัดเสร็จ {{formatDate(dt.cutstop_sv)}}</mat-label>
                            <input matInput style="text-align:center" [matDatepicker]="dp3"
                              style="text-align:center; background: #bdffad;" [ngModel]="dt.cutstop_edit"
                              (ngModelChange)="dt.cutstop_edit = Datetokeep($event); dt.modify = true;" disabled>
                            <mat-datepicker-toggle matSuffix [for]="dp3" color="accent"></mat-datepicker-toggle>
                            <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                            <button *ngIf="dt.cutstop_edit" matSuffix mat-icon-button color="warn" aria-label="Clear"
                              (click)="dt.cutstop_edit='';dt.modify = true;">
                              <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>
                        </div>
                      </td>

                      <td class="text-left">
                        <div *ngSwitchCase="false">{{dt.docCheckCutF}}</div>
                        <div *ngSwitchCase="true" (ngModelChange)="dt.modify = true">
                          <mat-form-field appearance="fill" style="max-width: 180px; text-align:left;">
                            <mat-label>เลือกผลลัพธ์</mat-label>
                            <mat-select disableRipple [(ngModel)]="dt.docCheckCutF_edit" style="background: #fccfb1;">
                              <mat-option value="ผลผลิตได้เกินเป้าหมาย">ผลผลิตได้เกินเป้าหมาย</mat-option>
                              <mat-option value="ผลผลิตได้ตามเป้าหมาย">ผลผลิตได้ตามเป้าหมาย</mat-option>
                              <mat-option value="ผลผลิตได้ต่ำกว่าเป้าหมาย">ผลผลิตได้ต่ำกว่าเป้าหมาย</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </td>
                      <td class="text-center">
                        <div *ngSwitchCase="false">{{dt.yieldDocCutF}} ตัน/ไร่</div>
                        <div *ngIf="edit_st && (dt.docCheckCutF_edit||0>0)">
                          <mat-form-field appearance="fill" style="max-width: 100px; text-align:center;">
                            <mat-label>ผลผลิต (ตัน/ไร่)</mat-label>
                            <input type="number" matInput style="text-align:center; width: 80px; background: #fccfb1;"
                              min="0" [(ngModel)]="dt.yieldDocCutF_edit" (ngModelChange)="dt.modify = true" />
                          </mat-form-field>
                        </div>
                      </td>
                      <td class="text-center">
                        {{(dt.BreedTon)| number}}
                        <!--{{dt.maxDateOut}} Cutseed_edit
                          <div *ngSwitchCase="false">{{(dt.Cutseed)| number}}</div>-->
                        <!--<input *ngSwitchCase="true" type="number" matInput
                            style="text-align:center; width: 85px; background: #ade5ff;" min="0"
                            [ngModel]="dt.Cutseed_edit" (ngModelChange)="dt.Cutseed_edit = $event; dt.modify = true" />
                        -->
                      </td>

                      <td class="text-center" [ngStyle]="{'background-color': 
                                  (dt.cutstatus_sv=='N') ? '#96ceb4' :
                                  (dt.cutstatus_sv=='Y') ? '#ffcc5c' :
                                  (dt.cutstatus_sv=='F') ? '#ff6f69' : null }">
                        <label *ngIf="dt.cutstatus_sv=='N'">ยังไม่ตัด</label>
                        <label *ngIf="dt.cutstatus_sv=='Y'">กำลังตัด</label>
                        <label *ngIf="dt.cutstatus_sv=='F'">ตัดเสร็จ</label>
                      </td>
                      <td>
                        <i class='far fa-edit' *ngIf="dt.modify" style='font-size:16px;color:red'></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-card>

          </div>
          <div class="tab-pane fade " id="tabs-showdata" role="tabpanel">
            <div class="row justify-content-md-center">
              <div class="col-md-4" *ngIf="sum_sv.length > 0">
                <div class="text-center">
                  <div class="btn-group mr-2" role="group" aria-label="Basic example" *ngFor="let sv of sum_sv">
                    <button type="button" class="btn btn-outline-secondary btn-sm"
                      [ngClass]="{'btn':true, 'active':sup == sv}" id="S{{sv}}"
                      (click)="filterBySup(sv)">{{sv}}</button>
                  </div>
                </div>
              </div>
              <div class="col-md-3" *ngIf="dataPlant.length > 0">
                <div class="button-row">
                  <span class="badge bg-warning">{{ dataPlant.length }}</span> รายการ
                  &nbsp; &nbsp;
                  <button mat-raised-button *ngIf="!edit_st2" (click)="edit_st2 = true">
                    <mat-icon style="color: blue;">edit</mat-icon>แก้ไข
                  </button>&nbsp;
                  <button mat-raised-button *ngIf="edit_st2" (click)="saveDoc()">
                    <mat-icon style="color: green;"> done </mat-icon>บันทึก
                  </button>&nbsp;
                  <button mat-raised-button *ngIf="edit_st2" (click)="edit_st2 = false">
                    <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
                  </button>
                </div>
              </div>
              <!--<div class="col-md-2">
                    <mat-form-field class="example-full-width" style="text-align:center">
                      <input matInput [(ngModel)]="text_f2" [ngModelOptions]="{standalone: true}" placeholder="คำค้นหา"
                        style="text-align:center">
                      <button *ngIf="text_f2" matSuffix mat-icon-button aria-label="Clear" (click)="text_f2=''">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>-->
            </div>

            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <mat-card class="example-card">
                  <table class="table table-hover table-striped table-head-fixed" #table02 *ngIf="dataPlant.length>0">
                    <thead>
                      <tr class="headText text-primary" style="text-align:center">
                        <th scope="col"></th>
                        <th scope="col">.</th>
                        <th scope="col">หมายเลขแปลง</th>
                        <th scope="col">โซน</th>
                        <th scope="col">นอส</th>
                        <th scope="col">รูท</th>
                        <th scope="col">ชื่อ - สกุล</th>
                        <th scope="col">ประเภทอ้อย</th>
                        <th scope="col">กลุ่ม</th>
                        <th scope="col">พื้นที่</th>
                        <th scope="col">ประเมิน</th>
                        <th scope="col">อ้อยเข้า</th>
                        <th scope="col">ตัดพันธุ์</th>
                        <th scope="col">%+-อ้อยเข้า</th>
                        <th scope="col">วันเริ่มตัด-ตัดเสร็จ</th>
                        <th scope="col">คำชี้แจง</th>
                        <th scope="col">สถานะการตัด</th>
                      </tr>
                    </thead>
                    <tbody [ngSwitch]="edit_st2">
                      <tr *ngFor="let dt of dataPlant | filter:text_f2; let i = index;" style="text-align:center"
                        [ngClass]="{'table-success under' : (dt.pcDifCanein >= -5&& dt.pcDifCanein <= 5) ,'table-warning under':(dt.pcDifCanein > 5) ,'table-danger under':(dt.pcDifCanein < -5  )}">
                        <td><i class='far fa-check-square' style='font-size:30px;color:red'
                            *ngIf="(((dt.docCheckCutF||'').toString()).length)>1"></i></td>
                        <td>{{i+1 | number}}
                          <i class='far fa-edit' *ngIf="dt.modify" style='font-size:12px;color:red'></i>
                        </td>
                        <td>{{dt.intlandno}}</td>
                        <td>{{dt.supzone}}</td>
                        <td>{{dt.supcode}}</td>
                        <td>{{dt.route}}</td>
                        <td style="text-align:left">{{dt.fmname}}</td>
                        <td>{{dt.CaneTypeName}}</td>
                        <td>{{dt.groupCode}}</td>
                        <td style="text-align:right">{{dt.landvalue | number:'1.2-2'}}</td>
                        <td style="text-align:right">{{dt.Assess_left | number:'1.2-2'}}</td>
                        <td style="text-align:right">{{dt.canein | number:'1.2-2'}}</td>
                        <td class="text-center">{{(dt.BreedTon)| number}}</td>
                        <td class="text-center">{{intDiff(dt.pcDifCanein)}}%</td>
                        <td>{{formatDate(dt.cutstart_sv)}} - {{formatDate(dt.cutstop_sv) }}</td>
                        <td style="text-align:left">
                          <div *ngSwitchCase="false">{{(dt.docCheckCutF)}}</div>
                          <!--<input *ngSwitchCase="true" type="text" matInput style="text-align:left; background: #adc7ff;"
                                  [(ngModel)]="dt.docCheckCutF" (ngModelChange)="dt.modify = true" />-->

                          <mat-form-field *ngSwitchCase="true" class="example-full-width" appearance="fill">
                            <mat-label>คำชี้แจง</mat-label>
                            <textarea matInput style=" background: #adc7ff;" [(ngModel)]="dt.docCheckCutF"
                              (ngModelChange)="dt.modify = true" placeholder="ระบุ คำชี้แจง"></textarea>
                          </mat-form-field>
                        </td>
                        <td class="text-center" Style="background-color:#ff6f69">
                          <label>ตัดเสร็จ</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </mat-card>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>